/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 15/05/2025 17:13
 *
 */

import { inject } from '@angular/core';
import { InitService, Logger } from '@infodata-group/inf-commons';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';
import { TitleTabService } from '../service/title-tab.service';

export const initializerFactory = () => {
  const initService = inject(InitService);
  const translateService = inject(TranslateService);
  const titleTabService = inject(TitleTabService);
  titleTabService.init();

  initService.isLoaded$.subscribe({
    next: (isLoaded) => {
      if (isLoaded) {
        try {
          const lang = navigator.language.split('-')[0].toLowerCase();
          if (translateService.langs.includes(lang)) {
            translateService.use(lang);
          }
        } catch (e) {
          Logger.e(`Impossible to init lang from browser`, e);
        }
      }
    },
    error: (e) => {
      Logger.w(e);
    },
  });
  initService.init(environment.appConfig);
};
